import { API_KEY } from "./constants/constants"
export const original = `/discover/tv?api_key=${API_KEY}&with_networks=213`
export const action = `/discover/tv?api_key=${API_KEY}&with_networks=28`